import React from 'react';
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig';

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'login-1',
        path: `${AUTH_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    },
    {
        key: 'register-1',
        path: `${AUTH_PREFIX_PATH}/register-1`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    // {
    //     key: 'error-page-1',
    //     path: `${AUTH_PREFIX_PATH}/error-page-1`,
    //     component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    // },
    // {
    //     key: 'error-page-2',
    //     path: `${AUTH_PREFIX_PATH}/error-page-2`,
    //     component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    // },
];

export const protectedRoutes = [
    {
        key: 'sso',
        path: `${APP_PREFIX_PATH}/sso`,
        component: React.lazy(() => import('views/app-views/sso')),
    },
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/sales')),
    },
    {
        key: 'dashboard.system_list',
        path: `${APP_PREFIX_PATH}/dashboards/system_list`,
        component: React.lazy(() => import('views/app-views/dashboards/system_list')),
    },
    {
        key: 'dashboard.analytic',
        path: `${APP_PREFIX_PATH}/dashboards/analytic`,
        component: React.lazy(() => import('views/app-views/dashboards/analytic')),
    },
    {
        key: 'dashboard.sales',
        path: `${APP_PREFIX_PATH}/dashboards/sales`,
        component: React.lazy(() => import('views/app-views/dashboards/sales')),
    },
    // {
    //     key: 'apps',
    //     path: `${APP_PREFIX_PATH}/apps`,
    //     component: React.lazy(() => import('views/app-views/apps')),
    // },
    {
        key: 'apps.notification',
        path: `${APP_PREFIX_PATH}/notification`,
        component: React.lazy(() => import('views/app-views/notification')),
    },
    {
        key: 'apps.notification.notification-list',
        path: `${APP_PREFIX_PATH}/notification/notification-list`,
        component: React.lazy(() => import('views/app-views/notification/notification-list')),
    },

    // {
    //     key: 'login-1',
    //     path: `${APP_PREFIX_PATH}/login-1`,
    //     component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    //     meta: {
    //         blankLayout: true,
    //     },
    // },

    {
        key: 'register-1',
        path: `${APP_PREFIX_PATH}/register-1`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
        meta: {
            blankLayout: true,
        },
    },

    {
        key: 'forgot-password',
        path: `${APP_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
        meta: {
            blankLayout: true,
        },
    },
    // {
    //     key: 'error-page-1',
    //     path: `${APP_PREFIX_PATH}/error-page-1`,
    //     component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    //     meta: {
    //         blankLayout: true,
    //     },
    // },
    {
        key: 'pages',
        path: `${APP_PREFIX_PATH}/pages`,
        component: React.lazy(() => import('views/app-views/pages')),
    },
    {
        key: 'pages.profile',
        path: `${APP_PREFIX_PATH}/pages/profile`,
        component: React.lazy(() => import('views/app-views/pages/profile')),
    },
    {
        key: 'pages.pricing',
        path: `${APP_PREFIX_PATH}/pages/pricing`,
        component: React.lazy(() => import('views/app-views/pages/pricing')),
    },
    {
        key: 'pages.faq',
        path: `${APP_PREFIX_PATH}/pages/faq`,
        component: React.lazy(() => import('views/app-views/pages/faq')),
    },
    {
        key: 'pages.setting',
        path: `${APP_PREFIX_PATH}/pages/setting/*`,
        component: React.lazy(() => import('views/app-views/pages/setting')),
    },
    {
        key: 'pages.user-list',
        path: `${APP_PREFIX_PATH}/pages/user-list`,
        component: React.lazy(() => import('views/app-views/pages/user-list')),
    },
    {
        key: 'docs.documentation',
        path: `${APP_PREFIX_PATH}/docs/documentation/*`,
        component: React.lazy(() => import('views/app-views/docs')),
    },

    
    /*-------------system----------------*/
    {
        key: 'apps.system',
        path: `${APP_PREFIX_PATH}/categories/system`,
        component: React.lazy(() => import('views/app-views/categories/system')),
    },
    {
        key: 'apps.system.system_list',
        path: `${APP_PREFIX_PATH}/categories/system/system_list`,
        component: React.lazy(() => import('views/app-views/categories/system/system_list')),
    },
    {
        key: 'apps.system.system_add',
        path: `${APP_PREFIX_PATH}/categories/system/system_add`,
        component: React.lazy(() => import('views/app-views/categories/system/system_add')),
    },
    {
        key: 'apps.system.system_add',
        path: `${APP_PREFIX_PATH}/categories/system/system_add/:id`,
        component: React.lazy(() => import('views/app-views/categories/system/system_add')),
    },
    {
        key: 'apps.system.system_edit',
        path: `${APP_PREFIX_PATH}/categories/system/system_edit/:id`,
        component: React.lazy(() => import('views/app-views/categories/system/system_edit')),
    },
    {
        key: 'apps.system.system_detail',
        path: `${APP_PREFIX_PATH}/categories/system/system_detail/:id`,
        component: React.lazy(() => import('views/app-views/categories/system/system_detail')),
    },
    {
        key: 'apps.system.system_masscopy',
        path: `${APP_PREFIX_PATH}/categories/system/system_masscopy`,
        component: React.lazy(() => import('views/app-views/categories/system/system_masscopy')),
    },
    {
        key: 'apps.system.system_export',
        path: `${APP_PREFIX_PATH}/categories/system/system_export`,
        component: React.lazy(() => import('views/app-views/categories/system/system_export')),
    },
    {
        key: 'apps.system.system_import',
        path: `${APP_PREFIX_PATH}/categories/system/system_import`,
        component: React.lazy(() => import('views/app-views/categories/system/system_import')),
    },
    {
        key: 'apps.system.system_trash',
        path: `${APP_PREFIX_PATH}/categories/system/system_trash`,
        component: React.lazy(() => import('views/app-views/categories/system/system_trash')),
    },
    /*-------------End of system----------------*/

    
    /*-------------action_type----------------*/
    {
        key: 'apps.action_type',
        path: `${APP_PREFIX_PATH}/categories/action_type`,
        component: React.lazy(() => import('views/app-views/categories/action_type')),
    },
    {
        key: 'apps.action_type.action_type_list',
        path: `${APP_PREFIX_PATH}/categories/action_type/action_type_list`,
        component: React.lazy(() => import('views/app-views/categories/action_type/action_type_list')),
    },
    {
        key: 'apps.action_type.action_type_add',
        path: `${APP_PREFIX_PATH}/categories/action_type/action_type_add`,
        component: React.lazy(() => import('views/app-views/categories/action_type/action_type_add')),
    },
    {
        key: 'apps.action_type.action_type_add',
        path: `${APP_PREFIX_PATH}/categories/action_type/action_type_add/:id`,
        component: React.lazy(() => import('views/app-views/categories/action_type/action_type_add')),
    },
    {
        key: 'apps.action_type.action_type_edit',
        path: `${APP_PREFIX_PATH}/categories/action_type/action_type_edit/:id`,
        component: React.lazy(() => import('views/app-views/categories/action_type/action_type_edit')),
    },
    {
        key: 'apps.action_type.action_type_detail',
        path: `${APP_PREFIX_PATH}/categories/action_type/action_type_detail/:id`,
        component: React.lazy(() => import('views/app-views/categories/action_type/action_type_detail')),
    },
    {
        key: 'apps.action_type.action_type_masscopy',
        path: `${APP_PREFIX_PATH}/categories/action_type/action_type_masscopy`,
        component: React.lazy(() => import('views/app-views/categories/action_type/action_type_masscopy')),
    },
    {
        key: 'apps.action_type.action_type_export',
        path: `${APP_PREFIX_PATH}/categories/action_type/action_type_export`,
        component: React.lazy(() => import('views/app-views/categories/action_type/action_type_export')),
    },
    {
        key: 'apps.action_type.action_type_import',
        path: `${APP_PREFIX_PATH}/categories/action_type/action_type_import`,
        component: React.lazy(() => import('views/app-views/categories/action_type/action_type_import')),
    },
    {
        key: 'apps.action_type.action_type_trash',
        path: `${APP_PREFIX_PATH}/categories/action_type/action_type_trash`,
        component: React.lazy(() => import('views/app-views/categories/action_type/action_type_trash')),
    },
    /*-------------End of action_type----------------*/

    
    /*-------------action----------------*/
    {
        key: 'apps.action',
        path: `${APP_PREFIX_PATH}/categories/action`,
        component: React.lazy(() => import('views/app-views/categories/action')),
    },
    {
        key: 'apps.action.action_list',
        path: `${APP_PREFIX_PATH}/categories/action/action_list`,
        component: React.lazy(() => import('views/app-views/categories/action/action_list')),
    },
    {
        key: 'apps.action.action_add',
        path: `${APP_PREFIX_PATH}/categories/action/action_add`,
        component: React.lazy(() => import('views/app-views/categories/action/action_add')),
    },
    {
        key: 'apps.action.action_add',
        path: `${APP_PREFIX_PATH}/categories/action/action_add/:id`,
        component: React.lazy(() => import('views/app-views/categories/action/action_add')),
    },
    {
        key: 'apps.action.action_edit',
        path: `${APP_PREFIX_PATH}/categories/action/action_edit/:id`,
        component: React.lazy(() => import('views/app-views/categories/action/action_edit')),
    },
    {
        key: 'apps.action.action_detail',
        path: `${APP_PREFIX_PATH}/categories/action/action_detail/:id`,
        component: React.lazy(() => import('views/app-views/categories/action/action_detail')),
    },
    {
        key: 'apps.action.action_masscopy',
        path: `${APP_PREFIX_PATH}/categories/action/action_masscopy`,
        component: React.lazy(() => import('views/app-views/categories/action/action_masscopy')),
    },
    {
        key: 'apps.action.action_export',
        path: `${APP_PREFIX_PATH}/categories/action/action_export`,
        component: React.lazy(() => import('views/app-views/categories/action/action_export')),
    },
    {
        key: 'apps.action.action_import',
        path: `${APP_PREFIX_PATH}/categories/action/action_import`,
        component: React.lazy(() => import('views/app-views/categories/action/action_import')),
    },
    {
        key: 'apps.action.action_trash',
        path: `${APP_PREFIX_PATH}/categories/action/action_trash`,
        component: React.lazy(() => import('views/app-views/categories/action/action_trash')),
    },
    /*-------------End of action----------------*/

    
    /*-------------module----------------*/
    {
        key: 'apps.module',
        path: `${APP_PREFIX_PATH}/categories/module`,
        component: React.lazy(() => import('views/app-views/categories/module')),
    },
    {
        key: 'apps.module.module_list',
        path: `${APP_PREFIX_PATH}/categories/module/module_list`,
        component: React.lazy(() => import('views/app-views/categories/module/module_list')),
    },
    {
        key: 'apps.module.module_add',
        path: `${APP_PREFIX_PATH}/categories/module/module_add`,
        component: React.lazy(() => import('views/app-views/categories/module/module_add')),
    },
    {
        key: 'apps.module.module_add',
        path: `${APP_PREFIX_PATH}/categories/module/module_add/:id`,
        component: React.lazy(() => import('views/app-views/categories/module/module_add')),
    },
    {
        key: 'apps.module.module_edit',
        path: `${APP_PREFIX_PATH}/categories/module/module_edit/:id`,
        component: React.lazy(() => import('views/app-views/categories/module/module_edit')),
    },
    {
        key: 'apps.module.module_detail',
        path: `${APP_PREFIX_PATH}/categories/module/module_detail/:id`,
        component: React.lazy(() => import('views/app-views/categories/module/module_detail')),
    },
    {
        key: 'apps.module.module_masscopy',
        path: `${APP_PREFIX_PATH}/categories/module/module_masscopy`,
        component: React.lazy(() => import('views/app-views/categories/module/module_masscopy')),
    },
    {
        key: 'apps.module.module_export',
        path: `${APP_PREFIX_PATH}/categories/module/module_export`,
        component: React.lazy(() => import('views/app-views/categories/module/module_export')),
    },
    {
        key: 'apps.module.module_import',
        path: `${APP_PREFIX_PATH}/categories/module/module_import`,
        component: React.lazy(() => import('views/app-views/categories/module/module_import')),
    },
    /*-------------End of module----------------*/

    
    /*-------------module_action----------------*/
    {
        key: 'apps.module_action',
        path: `${APP_PREFIX_PATH}/categories/module_action`,
        component: React.lazy(() => import('views/app-views/categories/module_action')),
    },
    {
        key: 'apps.module_action.module_action_list',
        path: `${APP_PREFIX_PATH}/categories/module_action/module_action_list`,
        component: React.lazy(() => import('views/app-views/categories/module_action/module_action_list')),
    },
    {
        key: 'apps.module_action.module_action_add',
        path: `${APP_PREFIX_PATH}/categories/module_action/module_action_add`,
        component: React.lazy(() => import('views/app-views/categories/module_action/module_action_add')),
    },
    {
        key: 'apps.module_action.module_action_add',
        path: `${APP_PREFIX_PATH}/categories/module_action/module_action_add/:id`,
        component: React.lazy(() => import('views/app-views/categories/module_action/module_action_add')),
    },
    {
        key: 'apps.module_action.module_action_edit',
        path: `${APP_PREFIX_PATH}/categories/module_action/module_action_edit/:id`,
        component: React.lazy(() => import('views/app-views/categories/module_action/module_action_edit')),
    },
    {
        key: 'apps.module_action.module_action_detail',
        path: `${APP_PREFIX_PATH}/categories/module_action/module_action_detail/:id`,
        component: React.lazy(() => import('views/app-views/categories/module_action/module_action_detail')),
    },
    {
        key: 'apps.module_action.module_action_masscopy',
        path: `${APP_PREFIX_PATH}/categories/module_action/module_action_masscopy`,
        component: React.lazy(() => import('views/app-views/categories/module_action/module_action_masscopy')),
    },
    {
        key: 'apps.module_action.module_action_export',
        path: `${APP_PREFIX_PATH}/categories/module_action/module_action_export`,
        component: React.lazy(() => import('views/app-views/categories/module_action/module_action_export')),
    },
    {
        key: 'apps.module_action.module_action_import',
        path: `${APP_PREFIX_PATH}/categories/module_action/module_action_import`,
        component: React.lazy(() => import('views/app-views/categories/module_action/module_action_import')),
    },
    /*-------------End of module_action----------------*/

    
    /*-------------system_module----------------*/
    {
        key: 'apps.system_module',
        path: `${APP_PREFIX_PATH}/categories/system_module`,
        component: React.lazy(() => import('views/app-views/categories/system_module')),
    },
    {
        key: 'apps.system_module.system_module_list',
        path: `${APP_PREFIX_PATH}/categories/system_module/system_module_list`,
        component: React.lazy(() => import('views/app-views/categories/system_module/system_module_list')),
    },
    {
        key: 'apps.system_module.system_module_add',
        path: `${APP_PREFIX_PATH}/categories/system_module/system_module_add`,
        component: React.lazy(() => import('views/app-views/categories/system_module/system_module_add')),
    },
    {
        key: 'apps.system_module.system_module_add',
        path: `${APP_PREFIX_PATH}/categories/system_module/system_module_add/:id`,
        component: React.lazy(() => import('views/app-views/categories/system_module/system_module_add')),
    },
    {
        key: 'apps.system_module.system_module_edit',
        path: `${APP_PREFIX_PATH}/categories/system_module/system_module_edit/:id`,
        component: React.lazy(() => import('views/app-views/categories/system_module/system_module_edit')),
    },
    {
        key: 'apps.system_module.system_module_detail',
        path: `${APP_PREFIX_PATH}/categories/system_module/system_module_detail/:id`,
        component: React.lazy(() => import('views/app-views/categories/system_module/system_module_detail')),
    },
    {
        key: 'apps.system_module.system_module_masscopy',
        path: `${APP_PREFIX_PATH}/categories/system_module/system_module_masscopy`,
        component: React.lazy(() => import('views/app-views/categories/system_module/system_module_masscopy')),
    },
    {
        key: 'apps.system_module.system_module_export',
        path: `${APP_PREFIX_PATH}/categories/system_module/system_module_export`,
        component: React.lazy(() => import('views/app-views/categories/system_module/system_module_export')),
    },
    {
        key: 'apps.system_module.system_module_import',
        path: `${APP_PREFIX_PATH}/categories/system_module/system_module_import`,
        component: React.lazy(() => import('views/app-views/categories/system_module/system_module_import')),
    },

    {
        key: 'apps.module.module_trash',
        path: `${APP_PREFIX_PATH}/categories/module/module_trash`,
        component: React.lazy(() => import('views/app-views/categories/module/module_trash')),
    },
    /*-------------End of system_module----------------*/

    
    /*-------------user----------------*/
    {
        key: 'apps.user',
        path: `${APP_PREFIX_PATH}/permissions/user`,
        component: React.lazy(() => import('views/app-views/permissions/user')),
    },
    {
        key: 'apps.user.user_list',
        path: `${APP_PREFIX_PATH}/permissions/user/user_list`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_list')),
    },
    {
        key: 'apps.user.user_add',
        path: `${APP_PREFIX_PATH}/permissions/user/user_add`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_add')),
    },
    {
        key: 'apps.user.user_add',
        path: `${APP_PREFIX_PATH}/permissions/user/user_add/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_add')),
    },
    {
        key: 'apps.user.user_edit',
        path: `${APP_PREFIX_PATH}/permissions/user/user_edit/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_edit')),
    },
    {
        key: 'apps.user.user_detail',
        path: `${APP_PREFIX_PATH}/permissions/user/user_detail/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_detail')),
    },
    {
        key: 'apps.user.user_masscopy',
        path: `${APP_PREFIX_PATH}/permissions/user/user_masscopy`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_masscopy')),
    },
    {
        key: 'apps.user.user_export',
        path: `${APP_PREFIX_PATH}/permissions/user/user_export`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_export')),
    },
    {
        key: 'apps.user.user_import',
        path: `${APP_PREFIX_PATH}/permissions/user/user_import`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_import')),
    },
    {
        key: 'apps.user.user_trash',
        path: `${APP_PREFIX_PATH}/permissions/user/user_trash`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_trash')),
    },
    {
        key: 'apps.user.user_edit_permission',
        path: `${APP_PREFIX_PATH}/permissions/user/user_edit_permission/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user/user_edit_permissions')),
    },
    /*-------------End of user----------------*/

    
    /*-------------role----------------*/
    {
        key: 'apps.role',
        path: `${APP_PREFIX_PATH}/permissions/role`,
        component: React.lazy(() => import('views/app-views/permissions/role')),
    },
    {
        key: 'apps.role.role_list',
        path: `${APP_PREFIX_PATH}/permissions/role/role_list`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_list')),
    },
    {
        key: 'apps.role.role_add',
        path: `${APP_PREFIX_PATH}/permissions/role/role_add`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_add')),
    },
    {
        key: 'apps.role.role_add',
        path: `${APP_PREFIX_PATH}/permissions/role/role_add/:id`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_add')),
    },
    {
        key: 'apps.role.role_edit',
        path: `${APP_PREFIX_PATH}/permissions/role/role_edit/:id`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_edit')),
    },
    {
        key: 'apps.role.role_detail',
        path: `${APP_PREFIX_PATH}/permissions/role/role_detail/:id`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_detail')),
    },
    {
        key: 'apps.role.role_masscopy',
        path: `${APP_PREFIX_PATH}/permissions/role/role_masscopy`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_masscopy')),
    },
    {
        key: 'apps.role.role_export',
        path: `${APP_PREFIX_PATH}/permissions/role/role_export`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_export')),
    },
    {
        key: 'apps.role.role_import',
        path: `${APP_PREFIX_PATH}/permissions/role/role_import`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_import')),
    },
    {
        key: 'apps.role.role_trash',
        path: `${APP_PREFIX_PATH}/permissions/role/role_trash`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_trash')),
    },
    {
        key: 'apps.role.role_edit_permission',
        path: `${APP_PREFIX_PATH}/permissions/role/role_edit_permission/:id`,
        component: React.lazy(() => import('views/app-views/permissions/role/role_edit_permissions')),
    },
    /*-------------End of role----------------*/

    
    /*-------------role_detail----------------*/
    {
        key: 'apps.role_detail',
        path: `${APP_PREFIX_PATH}/permissions/role_detail`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail')),
    },
    {
        key: 'apps.role_detail.role_detail_list',
        path: `${APP_PREFIX_PATH}/permissions/role_detail/role_detail_list`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail/role_detail_list')),
    },
    {
        key: 'apps.role_detail.role_detail_add',
        path: `${APP_PREFIX_PATH}/permissions/role_detail/role_detail_add`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail/role_detail_add')),
    },
    {
        key: 'apps.role_detail.role_detail_add',
        path: `${APP_PREFIX_PATH}/permissions/role_detail/role_detail_add/:id`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail/role_detail_add')),
    },
    {
        key: 'apps.role_detail.role_detail_edit',
        path: `${APP_PREFIX_PATH}/permissions/role_detail/role_detail_edit/:id`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail/role_detail_edit')),
    },
    {
        key: 'apps.role_detail.role_detail_detail',
        path: `${APP_PREFIX_PATH}/permissions/role_detail/role_detail_detail/:id`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail/role_detail_detail')),
    },
    {
        key: 'apps.role_detail.role_detail_masscopy',
        path: `${APP_PREFIX_PATH}/permissions/role_detail/role_detail_masscopy`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail/role_detail_masscopy')),
    },
    {
        key: 'apps.role_detail.role_detail_export',
        path: `${APP_PREFIX_PATH}/permissions/role_detail/role_detail_export`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail/role_detail_export')),
    },
    {
        key: 'apps.role_detail.role_detail_import',
        path: `${APP_PREFIX_PATH}/permissions/role_detail/role_detail_import`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail/role_detail_import')),
    },
    {
        key: 'apps.role_detail.role_detail_trash',
        path: `${APP_PREFIX_PATH}/permissions/role_detail/role_detail_trash`,
        component: React.lazy(() => import('views/app-views/permissions/role_detail/role_detail_trash')),
    },
    /*-------------End of role_detail----------------*/

    
    /*-------------user_role----------------*/
    {
        key: 'apps.user_role',
        path: `${APP_PREFIX_PATH}/permissions/user_role`,
        component: React.lazy(() => import('views/app-views/permissions/user_role')),
    },
    {
        key: 'apps.user_role.user_role_list',
        path: `${APP_PREFIX_PATH}/permissions/user_role/user_role_list`,
        component: React.lazy(() => import('views/app-views/permissions/user_role/user_role_list')),
    },
    {
        key: 'apps.user_role.user_role_add',
        path: `${APP_PREFIX_PATH}/permissions/user_role/user_role_add`,
        component: React.lazy(() => import('views/app-views/permissions/user_role/user_role_add')),
    },
    {
        key: 'apps.user_role.user_role_add',
        path: `${APP_PREFIX_PATH}/permissions/user_role/user_role_add/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user_role/user_role_add')),
    },
    {
        key: 'apps.user_role.user_role_edit',
        path: `${APP_PREFIX_PATH}/permissions/user_role/user_role_edit/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user_role/user_role_edit')),
    },
    {
        key: 'apps.user_role.user_role_detail',
        path: `${APP_PREFIX_PATH}/permissions/user_role/user_role_detail/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user_role/user_role_detail')),
    },
    {
        key: 'apps.user_role.user_role_masscopy',
        path: `${APP_PREFIX_PATH}/permissions/user_role/user_role_masscopy`,
        component: React.lazy(() => import('views/app-views/permissions/user_role/user_role_masscopy')),
    },
    {
        key: 'apps.user_role.user_role_export',
        path: `${APP_PREFIX_PATH}/permissions/user_role/user_role_export`,
        component: React.lazy(() => import('views/app-views/permissions/user_role/user_role_export')),
    },
    {
        key: 'apps.user_role.user_role_import',
        path: `${APP_PREFIX_PATH}/permissions/user_role/user_role_import`,
        component: React.lazy(() => import('views/app-views/permissions/user_role/user_role_import')),
    },
    {
        key: 'apps.user_role.user_role_trash',
        path: `${APP_PREFIX_PATH}/permissions/user_role/user_role_trash`,
        component: React.lazy(() => import('views/app-views/permissions/user_role/user_role_trash')),
    },
    /*-------------End of user_role----------------*/

    
    /*-------------user_permission----------------*/
    {
        key: 'apps.user_permission',
        path: `${APP_PREFIX_PATH}/permissions/user_permission`,
        component: React.lazy(() => import('views/app-views/permissions/user_permission')),
    },
    {
        key: 'apps.user_permission.user_permission_list',
        path: `${APP_PREFIX_PATH}/permissions/user_permission/user_permission_list`,
        component: React.lazy(() => import('views/app-views/permissions/user_permission/user_permission_list')),
    },
    {
        key: 'apps.user_permission.user_permission_add',
        path: `${APP_PREFIX_PATH}/permissions/user_permission/user_permission_add`,
        component: React.lazy(() => import('views/app-views/permissions/user_permission/user_permission_add')),
    },
    {
        key: 'apps.user_permission.user_permission_add',
        path: `${APP_PREFIX_PATH}/permissions/user_permission/user_permission_add/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user_permission/user_permission_add')),
    },
    {
        key: 'apps.user_permission.user_permission_edit',
        path: `${APP_PREFIX_PATH}/permissions/user_permission/user_permission_edit/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user_permission/user_permission_edit')),
    },
    {
        key: 'apps.user_permission.user_permission_detail',
        path: `${APP_PREFIX_PATH}/permissions/user_permission/user_permission_detail/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user_permission/user_permission_detail')),
    },
    {
        key: 'apps.user_permission.user_permission_masscopy',
        path: `${APP_PREFIX_PATH}/permissions/user_permission/user_permission_masscopy`,
        component: React.lazy(() => import('views/app-views/permissions/user_permission/user_permission_masscopy')),
    },
    {
        key: 'apps.user_permission.user_permission_export',
        path: `${APP_PREFIX_PATH}/permissions/user_permission/user_permission_export`,
        component: React.lazy(() => import('views/app-views/permissions/user_permission/user_permission_export')),
    },
    {
        key: 'apps.user_permission.user_permission_import',
        path: `${APP_PREFIX_PATH}/permissions/user_permission/user_permission_import`,
        component: React.lazy(() => import('views/app-views/permissions/user_permission/user_permission_import')),
    },
    /*-------------End of user_permission----------------*/

    
    /*-------------access_log----------------*/
    {
        key: 'apps.access_log',
        path: `${APP_PREFIX_PATH}/permissions/access_log`,
        component: React.lazy(() => import('views/app-views/permissions/access_log')),
    },
    {
        key: 'apps.access_log.access_log_list',
        path: `${APP_PREFIX_PATH}/permissions/access_log/access_log_list`,
        component: React.lazy(() => import('views/app-views/permissions/access_log/access_log_list')),
    },
    {
        key: 'apps.access_log.access_log_add',
        path: `${APP_PREFIX_PATH}/permissions/access_log/access_log_add`,
        component: React.lazy(() => import('views/app-views/permissions/access_log/access_log_add')),
    },
    {
        key: 'apps.access_log.access_log_add',
        path: `${APP_PREFIX_PATH}/permissions/access_log/access_log_add/:id`,
        component: React.lazy(() => import('views/app-views/permissions/access_log/access_log_add')),
    },
    {
        key: 'apps.access_log.access_log_edit',
        path: `${APP_PREFIX_PATH}/permissions/access_log/access_log_edit/:id`,
        component: React.lazy(() => import('views/app-views/permissions/access_log/access_log_edit')),
    },
    {
        key: 'apps.access_log.access_log_detail',
        path: `${APP_PREFIX_PATH}/permissions/access_log/access_log_detail/:id`,
        component: React.lazy(() => import('views/app-views/permissions/access_log/access_log_detail')),
    },
    {
        key: 'apps.access_log.access_log_masscopy',
        path: `${APP_PREFIX_PATH}/permissions/access_log/access_log_masscopy`,
        component: React.lazy(() => import('views/app-views/permissions/access_log/access_log_masscopy')),
    },
    {
        key: 'apps.access_log.access_log_export',
        path: `${APP_PREFIX_PATH}/permissions/access_log/access_log_export`,
        component: React.lazy(() => import('views/app-views/permissions/access_log/access_log_export')),
    },
    {
        key: 'apps.access_log.access_log_import',
        path: `${APP_PREFIX_PATH}/permissions/access_log/access_log_import`,
        component: React.lazy(() => import('views/app-views/permissions/access_log/access_log_import')),
    },
    /*-------------End of access_log----------------*/


    /*-------------user_data_scope----------------*/
    {
        key: 'apps.user_data_scope',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope')),
    },
    {
        key: 'apps.user_data_scope.user_data_scope_list',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope/user_data_scope_list`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope/user_data_scope_list')),
    },
    {
        key: 'apps.user_data_scope.user_data_scope_add',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope/user_data_scope_add`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope/user_data_scope_add')),
    },
    {
        key: 'apps.user_data_scope.user_data_scope_add',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope/user_data_scope_add/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope/user_data_scope_add')),
    },
    {
        key: 'apps.user_data_scope.user_data_scope_edit',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope/user_data_scope_edit/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope/user_data_scope_edit')),
    },
    {
        key: 'apps.user_data_scope.user_data_scope_detail',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope/user_data_scope_detail/:id`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope/user_data_scope_detail')),
    },
    {
        key: 'apps.user_data_scope.user_data_scope_masscopy',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope/user_data_scope_masscopy`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope/user_data_scope_masscopy')),
    },
    {
        key: 'apps.user_data_scope.user_data_scope_export',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope/user_data_scope_export`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope/user_data_scope_export')),
    },
    {
        key: 'apps.user_data_scope.user_data_scope_import',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope/user_data_scope_import`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope/user_data_scope_import')),
    },
    {
        key: 'apps.user_data_scope.user_data_scope_trash',
        path: `${APP_PREFIX_PATH}/permissions/user_data_scope/user_data_scope_trash`,
        component: React.lazy(() => import('views/app-views/permissions/user_data_scope/user_data_scope_trash')),
    },
    /*-------------End of user_data_scope----------------*/

    

];
